class MFRLogoCarousel {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            wrapper: ".logo-carousel",
            nav: ".logo-carousel__nav-item[data-index]",
            carousel: ".logo-carousel__carousel",
            logo: ".logo-carousel__logo"
        };

        this.init();
    }

    init() {
        this.$nav = this.$element.find( this.selectors.nav );
        this.$carousel = this.$element.find( this.selectors.carousel );
        this.$logo = this.$element.find( this.selectors.logo );
        this.$wrapper = this.$element.find( this.selectors.wrapper );

        this.logosAsNav = this.$wrapper.data( "logo-as-nav" );

        this.initCarousel();
    }

    initCarousel() {
        this.$carousel.flickity({
          selectedAttraction: 0.1,
          friction: 0.55,
          wrapAround: true,
          contain: true,
          prevNextButtons: true,
          pageDots: false,
          autoPlay: 4000,
          on: {
            change: (i) => this.changeLogo(i),
            ready: () => this.setSlide(),
          },
        });
    }

    changeLogo( i ) {
        this.animmateChange( this.$logo, this.$element.find( this.selectors.nav + `[data-index="${ i }"] img` ).clone() );
    }

    setSlide() {
        if (!this.logosAsNav) return;

        this.$nav.on("click", (e) =>
            this.$carousel.flickity("select", $(e.currentTarget).data("index"))
        );
    }

    animmateChange( element, value, animate = true ) {
        if( animate ) {
            // if( span.html() == value ) return;
            gsap.to( element, {
                yPercent: 101,
                duration: .4,
                ease: "power4.out",
                onComplete: () => {
                    element.html( value );
                    gsap.to( element, {
                        yPercent: 0,
                        duration: .8
                    } );
                }
            } );
        }
        else {
            span.html( value );
        }
    }
}